import chroma from 'chroma-js';
import type { UseFormGetValues, UseFormSetValue } from 'react-hook-form';
import { StyleSheet } from 'react-native-unistyles';
import Avatar from '@/components/Custom/Avatar';
import * as Header from '@/components/Custom/Header';
import type { EventEditFormValues } from '@/components/Event/EventEdit.types';
import Badge from '@/components/UI/Badge';
import Box from '@/components/UI/Box';
import Row from '@/components/UI/Row';
import Text from '@/components/UI/Text';
import Icon from '@/components/Unistyles/Icon';
import getEmptyEntity from '@/utils/getEmptyEntity';
import getOffsetColor from '@/utils/getOffsetColor';
import getRandomColor from '@/utils/getRandomColor';
import type { EntityListField } from '../Entity/EntityList.types';

const styles = StyleSheet.create((theme) => ({
  teamRow: {
    height: theme.size(12),
    borderWidth: 0,
  },
}));
function EventEditTeamListItem({
  team,
  index,
  setValue,
  getValues,
  isGame,
}: {
  team: EntityListField;
  index: number;
  setValue: UseFormSetValue<EventEditFormValues>;
  getValues: UseFormGetValues<EventEditFormValues>;
  isGame: boolean;
}) {
  const onPressDelete = () => {
    const formTeams = getValues('teams');
    if (index !== -1 && formTeams) {
      setValue(
        'teams',
        formTeams.map((formTeam, i) =>
          i === index
            ? getEmptyEntity(formTeam.color || getRandomColor())
            : formTeam,
        ),
        {
          shouldDirty: true,
          shouldValidate: true,
        },
      );
    }
  };
  const onPressSwapHomeAway = () => {
    const formTeams = getValues('teams');
    if (formTeams) {
      setValue(
        'teams',
        formTeams.map((formTeam, i) =>
          i === 0 ? formTeams[1] : i === 1 ? formTeams[0] : formTeam,
        ),
        {
          shouldDirty: true,
        },
      );
    }
  };
  const teamColor = team.title && team.color ? team.color : '';
  const teamOffsetColor = teamColor ? getOffsetColor(teamColor, false) : '';
  const teamHoverColor = teamColor
    ? chroma.scale([teamColor, teamOffsetColor]).colors(3)[1]
    : '';
  return (
    <Row
      spaced
      testID="EventEditTeamListItem"
      style={styles.teamRow}
      backgroundColor={teamOffsetColor || undefined}
    >
      <Box direction="horizontal" space="md" align="center" flexShrink={1}>
        <Avatar
          id={team.avatarId || ''}
          color={teamColor}
          name={team.title || ''}
        />
        <Text
          numberOfLines={1}
          flexShrink={1}
          flexGrow={0}
          color={teamColor || undefined}
          fontWeight="semibold"
        >
          {team.title || `Team Slot ${index + 1}`}
        </Text>
      </Box>
      <Box direction="horizontal" space="md" align="center">
        {team.title && index === 0 && isGame ? (
          <Badge color={teamColor}>
            <Badge.Text>Away</Badge.Text>
          </Badge>
        ) : null}
        {team.title && index === 1 && isGame ? (
          <Badge color={teamColor}>
            <Badge.Text>Home</Badge.Text>
          </Badge>
        ) : null}
        {team.title && isGame ? (
          <Header.Button
            onPress={onPressSwapHomeAway}
            $hover-bg={teamHoverColor}
            $active-bg={teamHoverColor}
          >
            <Icon
              color={teamColor}
              name={index === 1 ? 'arrow-up-outline' : 'arrow-down-outline'}
            />
          </Header.Button>
        ) : null}

        {team.title ? (
          <Header.Button
            onPress={onPressDelete}
            $hover-bg={teamHoverColor}
            $active-bg={teamHoverColor}
          >
            <Icon color={teamColor} name="close-outline" />
          </Header.Button>
        ) : null}
      </Box>
    </Row>
  );
}
export default EventEditTeamListItem;
